<div class="{uiClasses}{classMap getStateClasses}input" part="input">
  <input type="{type}" placeholder="{placeholder}" disabled={disabled} name={name} value={value} part="input-field">
  {#if icon}
    {#if isClearable}
      <ui-icon icon="x" link class="clickable icon" part="icon"></ui-icon>
    {else}
      <ui-icon icon={getIcon} class="icon" part="icon"></ui-icon>
    {/if}
  {/if}
  {#if label}
    <div class="label" part="label">
      {label}
    </div>
  {/if}
</div>
